let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("gx4db")).then(() => parcelRequire('1FtPF'));